/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DetailedCompanyCto } from '../../models/detailed-company-cto';
import { EditCompanyCto } from '../../models/edit-company-cto';

export interface UpdateCompany$Json$Params {
  companyId: string;
      body?: EditCompanyCto
}

export function updateCompany$Json(http: HttpClient, rootUrl: string, params: UpdateCompany$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DetailedCompanyCto>> {
  const rb = new RequestBuilder(rootUrl, updateCompany$Json.PATH, 'put');
  if (params) {
    rb.path('companyId', params.companyId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DetailedCompanyCto>;
    })
  );
}

updateCompany$Json.PATH = '/company/{companyId}';
